import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState, BaasicModal } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';
import { ApplicationSettingEdit } from "application/application-setting/components";

function ApplicationSettingListTemplate({ listViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization,
        editModal
    } = listViewStore;
    return (
        <ApplicationListLayout store={listViewStore}>
            <Content  emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility}/>
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
                <BaasicModal modalParams={editModal} className="modal__content modal--sml">
                    <ApplicationSettingEdit />
                </BaasicModal>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='APPLICATION_SETTING.LIST.EMPTY_STATE.TITLE' description='APPLICATION_SETTING.LIST.EMPTY_STATE.DESCRIPTION' />
}

ApplicationSettingListTemplate.propTypes = {
    listViewStore: PropTypes.object
};

export default defaultTemplate(ApplicationSettingListTemplate);
